import { useEffect, useRef } from 'preact/hooks';

const PostHaiForm = (props) => {
  const { token, url, config, beaconAction, spaceKey } = props;
  const ref = useRef(null);

  useEffect(() => {
    if (token && url) {
      beaconAction?.current?.onDirectUserAction('IDE_show', {
        user_id: config.userInfo?.data?.id, // 用户id
        channel: 'CS',
        workspace_id: spaceKey, // 工作空间id
      });
      ref?.current?.submit();
    }
  }, [token, url]);

  return (
    <form ref={ref} action={url} method='post' style={{ position: 'absolute', left: '-100%', top: '-100%' }}>
      <input type='hidden' name='token' value={token} />
    </form>
  );
};

export default PostHaiForm;
